export default "__VITE_ASSET__FdW8epNN__"